<template>
  <nav class="navbar" :class="{ 'scrolled': isScrolled }">
    <div class="nav-container">
      <div class="logo">
        <router-link to="/">
          <img src="/logo.png" alt="宠物星系" class="logo-img">
        </router-link>
      </div>
      <ul class="nav-menu" :class="{ 'active': isMenuOpen }">
        <li v-for="item in menuItems" :key="item.path">
          <router-link :to="item.path" @click="closeMenu">{{ item.name }}</router-link>
        </li>
      </ul>
      <div class="hamburger" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      isMenuOpen: false,
      isScrolled: false,
      menuItems: [
        { name: '首页', path: '/' },
        { name: '纪念馆', path: '/memorial' },
        { name: '造坊处', path: '/shop' },
        { name: '宠星故事&周刊', path: '/story' },
        { name: '品牌故事&联系我们', path: '/brand' }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(15, 12, 41, 0.95);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  padding: 15px 0;
}

.navbar.scrolled {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 20px rgba(48, 43, 99, 0.1);
  padding: 10px 0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo a {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-img {
  height: 40px;
  width: auto;
  transition: all 0.3s ease;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 40px;
}

.nav-menu a {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
}

.navbar.scrolled .nav-menu a {
  color: #302b63;
}

.nav-menu a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #7b68ee, #9d7bff);
  transition: width 0.3s ease;
}

.nav-menu a:hover {
  color: #fff;
}

.navbar.scrolled .nav-menu a:hover {
  color: #7b68ee;
}

.nav-menu a:hover::after,
.nav-menu a.router-link-active::after {
  width: 100%;
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
}

.hamburger span {
  width: 25px;
  height: 3px;
  background: #fff;
  transition: all 0.3s ease;
}

.navbar.scrolled .hamburger span {
  background: #302b63;
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .nav-menu {
    position: fixed;
    left: -100%;
    top: 70px;
    flex-direction: column;
    background: #fff;
    width: 100%;
    text-align: center;
    transition: 0.3s;
    box-shadow: 0 10px 27px rgba(48, 43, 99, 0.1);
    padding: 20px 0;
    gap: 20px;
  }

  .nav-menu.active {
    left: 0;
  }

  .nav-menu a {
    color: #302b63 !important;
  }
}
</style>
